var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMainLogoTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 58,
    viewBox: "0 0 35 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2209_4945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0371 14.9004C23.9714 14.9004 15.7658 21.1123 15.7656 28.7197V57.123H7.79297V28.7197C7.79309 16.694 19.5531 6.92774 34.0371 6.92773V14.9004ZM34.0371 1.44629C25.9646 1.44629 18.2579 4.03766 12.3779 8.72168C5.99967 13.8708 2.31158 21.1456 2.31152 28.7197H0.982422C0.982481 20.7469 4.83643 13.0731 11.5469 7.69141C17.6594 2.80802 25.6656 0.117188 34.0371 0.117188V1.44629Z",
    fill: "#1B1F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8876 33.8358C31.9149 33.8358 34.369 31.3817 34.369 28.3544C34.369 25.3271 31.9149 22.873 28.8876 22.873C25.8603 22.873 23.4062 25.3271 23.4062 28.3544C23.4062 31.3817 25.8603 33.8358 28.8876 33.8358Z",
    fill: "#85F2A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2209_4945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4687,
    height: 57.006,
    fill: "white",
    transform: "translate(-0.0996094 0.117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMainLogoTablet);
export default __webpack_public_path__ + "static/media/ic_main_logo_tablet.f742136232ea8fc85620e7a4c8bd1b5b.svg";
export { ForwardRef as ReactComponent };